import { PushLiens } from '@components/push-liens/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const pushLiensMock: Block<PushLiens> = {
  type: 'push-liens',
  data: {
    title: "Besoin de plus d'infos ?",
    links: [
      {
        image: imageMock,
        cta: {
          label: 'Consultez la plaquette',
          url: '/mock-espace-franchise/des-cuisinistes-pas-comme-les-autres',
        },
      },
      {
        image: imageMock,
        cta: {
          label: 'Consultez le catalogue',
          url: '/mock-catalogue',
        },
      },
    ],
    gtmConfigCta1: {
      event: 'click_cta_plaquette_f_voir',
      group: 'catalogue',
      description: 'infos franchise',
      context: 'consultation de la plaquette franchise',
    },
    gtmConfigCta2: {
      event: 'click_cta_catalogue_f_voir',
      group: 'catalogue',
      description: 'infos franchise',
      context: 'consultation du catalogue franchise',
    },
  },
};
